import { Text } from "@mantine/core";
import { IconChevronLeft } from "@tabler/icons-react"
import { useNavigate} from 'react-router-dom'; 

const BackButton = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  }
  return <button onClick={handleGoBack} className="text-secondary-text-color flex items-center py-2"><IconChevronLeft /> <Text className="text-sm" style={{ fontSize: '1.5rem' }} >Back</Text></button>
}

export default BackButton;